const AnalyticssStorage = {
    state: {
      AnalyticStatus: null,
      Maxi_Min: null,
    },
    mutations: {
        SET_STATUS_MUTUATION: (state, payload) => {
        state.AnalyticStatus = payload
      },
      SET_Maxi_Min_MUTUATION: (state, payload) => {
        state.Maxi_Min = payload
      }
    },
    actions: {
        SET_Analytics_STATUS:({commit}, payload) => {
        commit('SET_STATUS_MUTUATION', payload)
      },
      SET_Analytics_Maxi_Min_STATUS:({commit}, payload) => {
        commit('SET_Maxi_Min_MUTUATION', payload)
      }
    },
    getters: {
      get_status: (state) => {
        return state.AnalyticStatus
      },
       get_maxi_min: (state) => {
        return state.Maxi_Min
      }
    }
  }
  export default AnalyticssStorage
      